export class JobRate {
    maxRate:number = 0;
    minRate:number = 0;
    rateType:any = null;
    rateDuration:any = "PER_HOUR";
    currency:any = null;
}